import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLectureQuizQuestions } from "../../../../services/dashboard/apiQuizes";

export function useLectureQuizQuestions({
  courseId,
  lectureId,
  itemId,
  filter,
  fields,
  includeFields,
  perPage,
  searchValue,
  sortBy,
  page,
  filterAndSortAndPageQuery,
} = {}) {
  const queryClient = useQueryClient();

  const {
    data: quizQuestions,
    isPending,
    isSuccess,
  } = useQuery({
    queryKey: [
      "quizQuestionsDB",
      courseId,
      lectureId,
      itemId,
      filter,
      fields,
      includeFields,
      perPage,
      searchValue,
      sortBy,
      page,
      filterAndSortAndPageQuery,
    ],
    queryFn: () =>
      getLectureQuizQuestions({
        courseId,
        lectureId,
        itemId,
        filter,
        fields,
        includeFields,
        perPage,
        searchValue,
        sortBy,
        page,
        filterAndSortAndPageQuery,
      }),
  });

  const totalPages = Math.ceil(
    quizQuestions?.meta?.total / quizQuestions?.meta?.per_page
  );

  // PRE-FETCHING;
  if (isSuccess && page < totalPages) {
    queryClient.prefetchQuery({
      queryKey: [
        "quizQuestionsDB",
        courseId,
        lectureId,
        itemId,
        filter,
        fields,
        includeFields,
        perPage,
        searchValue,
        sortBy,
        page,
        filterAndSortAndPageQuery,
      ],
      queryFn: () =>
        getLectureQuizQuestions({
          courseId,
          lectureId,
          itemId,
          filter,
          fields,
          includeFields,
          perPage,
          searchValue,
          sortBy,
          page,
          filterAndSortAndPageQuery,
        }),
    });
  }

  if (isSuccess && page > 1) {
    queryClient.prefetchQuery({
      queryKey: [
        "quizQuestionsDB",
        courseId,
        lectureId,
        itemId,
        filter,
        fields,
        includeFields,
        perPage,
        searchValue,
        sortBy,
        page,
        filterAndSortAndPageQuery,
      ],
      queryFn: () =>
        getLectureQuizQuestions({
          courseId,
          lectureId,
          itemId,
          filter,
          fields,
          includeFields,
          perPage,
          searchValue,
          sortBy,
          page,
          filterAndSortAndPageQuery,
        }),
    });
  }

  return { isPending, quizQuestions };
}
